(function () {
  var D = window.BH_QUIZ_DATA;
  var root = document.getElementById('bh-q');
  if (!D || !root) return;

  var mount = document.getElementById('bh-q-mount');
  var prog = document.getElementById('bh-q-prog');
  var back = document.getElementById('bh-q-back');
  var links = window.BH_QUIZ_LINKS || {};

  var Q = D.questions;
  var i = 0;
  var A = {};

  try { A = JSON.parse(localStorage.getItem('bh_quiz') || '{}'); } catch (e) { A = {}; }
  function save() { try { localStorage.setItem('bh_quiz', JSON.stringify(A)); } catch (e) {} }

  function countIn(c) { return Q.filter(function (q) { return q.c === c; }).length; }
  function indexIn(c, upto) {
    var n = 0;
    for (var k = 0; k < upto; k++) { if (Q[k].c === c) n++; }
    return n;
  }

  function toTop() {
    window.scrollTo(0, 0);
    var pw = document.querySelector('.page-wrapper');
    if (pw) pw.scrollTop = 0;
  }

  function drawProg(done) {
    prog.innerHTML = '';
    D.chapters.forEach(function (name, c) {
      var seg = document.createElement('div');
      seg.className = 'bh-q__seg';
      var pct = 0;
      if (done) {
        pct = 100;
      } else if (Q[i] && Q[i].c === c) {
        seg.className += ' is-live';
        pct = Math.round(indexIn(c, i) / countIn(c) * 100);
      } else if (Q[i] && Q[i].c > c) {
        pct = 100;
      }
      var fill = document.createElement('span');
      fill.className = 'bh-q__fill';
      fill.style.width = pct + '%';
      var lab = document.createElement('span');
      lab.textContent = name;
      seg.appendChild(fill);
      seg.appendChild(lab);
      prog.appendChild(seg);
    });
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function render() {
    if (i >= Q.length) { return result(); }
    var q = Q[i];
    drawProg(false);
    back.hidden = i === 0;

    var cur = A[q.id];
    var picked = q.multi ? (Array.isArray(cur) ? cur : []) : cur;

    var h = '<p class="bh-q__k">' + esc(D.chapters[q.c]) + '</p>';
    h += '<h1 class="bh-q__t">' + esc(q.t) + '</h1>';
    if (q.s) { h += '<p class="bh-q__s">' + esc(q.s) + '</p>'; }
    h += '<div class="bh-q__opts" role="' + (q.multi ? 'group' : 'radiogroup') + '">';
    q.o.forEach(function (pair) {
      var on = q.multi ? picked.indexOf(pair[0]) > -1 : picked === pair[0];
      h += '<button type="button" class="bh-q__opt' + (on ? ' is-on' : '') + '" data-v="' + esc(pair[0]) + '">';
      if (q.multi) { h += '<span class="bh-q__box"></span>'; }
      h += '<span>' + esc(pair[1]) + '</span></button>';
    });
    h += '</div>';
    if (q.multi) { h += '<button type="button" class="bh-btn bh-q__next" id="bh-q-next">Next</button>'; }
    mount.innerHTML = h;
    mount.className = 'bh-q__inner';

    mount.querySelectorAll('.bh-q__opt').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-v');

        if (!q.multi) {
          A[q.id] = v; save(); i++; render();
          return;
        }

        var arr = Array.isArray(A[q.id]) ? A[q.id].slice() : [];
        if (v === 'none') {
          // exclusive option: toggle it on its own, never fold into the list
          arr = (arr.length === 1 && arr[0] === 'none') ? [] : ['none'];
        } else {
          arr = arr.filter(function (x) { return x !== 'none'; });
          var at = arr.indexOf(v);
          if (at > -1) { arr.splice(at, 1); } else { arr.push(v); }
        }
        A[q.id] = arr;
        save();
        render();
      });
    });

    var nx = document.getElementById('bh-q-next');
    if (nx) { nx.addEventListener('click', function () { i++; render(); }); }
    toTop();
  }

  function result() {
    drawProg(true);
    back.hidden = false;

    var treat = Array.isArray(A.treat) ? A.treat : [];
    var scalpIssue = A.scalp === 'oily' || A.scalp === 'mixed' || A.flake === 'yes' || A.sensitive === 'often';
    var breakage = A.where === 'ends' || A.change === 'dry' || treat.indexOf('heat') > -1 || treat.indexOf('colour') > -1;

    var lead, why;
    if (scalpIssue) {
      lead = 'Start with the scalp.';
      why = 'Your answers point at the scalp environment before the strand. Buildup, flaking and sensitivity all change what a follicle can do, and they are the fastest thing to shift. Step One and Step Two carry most of the work for you.';
    } else if (breakage) {
      lead = 'Start with breakage.';
      why = 'What reads as thinning is often length being lost rather than density. Colour, heat and dryness break the shaft mid-length, so hair never reaches the length it used to. Step Three matters more for you than it does for most people.';
    } else {
      lead = 'Start at the parting.';
      why = 'Your answers describe the classic pattern through the change: a shorter growing phase, so strands arrive finer and leave sooner. That is what the full three-step protocol is built around, and it is why it takes a full cycle.';
    }

    var stageMap = { pre: 'before the change', peri: 'perimenopause', meno: 'menopause', post: 'post-menopause', unsure: 'the change' };
    var stage = stageMap[A.stage] || 'the change';

    var goalMap = { fullness: 'fullness at the parting', shedding: 'less shedding', breakage: 'less breakage', calm: 'a calmer scalp' };
    var goals = (Array.isArray(A.goal) ? A.goal : []).map(function (g) { return goalMap[g]; }).filter(Boolean);
    var goalLine = goals.length
      ? (goals.length > 1 ? goals.slice(0, -1).join(', ') + ' and ' + goals[goals.length - 1] : goals[0])
      : 'more fullness';

    var protocol = links.protocol || '/products/the-90-day-protocol';
    var serum = links.serum || '/products/step-two-scalp-serum';

    var h = '<div class="bh-q__res">';
    h += '<p class="bh-q__k">Your consultation</p>';
    h += '<h1 class="bh-q__t" style="font-size:2.25rem">' + esc(lead) + '</h1>';
    h += '<div class="bh-q__rescard">';
    h += '<div class="bh-q__row"><div class="bh-q__rk">Where you are</div><p class="bh-body bh-small" style="flex:1">You told us you are in ' + esc(stage) + ', and that what matters most is ' + esc(goalLine) + '.</p></div>';
    h += '<div class="bh-q__row"><div class="bh-q__rk">What we read</div><p class="bh-body bh-small" style="flex:1">' + esc(why) + '</p></div>';
    h += '<div class="bh-q__row"><div class="bh-q__rk">Your timeline</div><p class="bh-body bh-small" style="flex:1">Day 30, expect to see nothing. Day 60, shedding usually settles first. Day 90, a strand that started growing when you did has finally reached the length where it shows at the parting. Photograph your parting in the same light on day one so you have something to judge against.</p></div>';
    h += '<div class="bh-q__row"><div class="bh-q__rk">Honestly</div><p class="bh-body bh-small" style="flex:1">This will not regrow hair. Nothing sold as a cosmetic will. If regrowth is what you are after, that is a conversation for your doctor.</p></div>';
    h += '</div>';
    h += '<div class="bh-q__cta">';
    h += '<a class="bh-btn" href="' + protocol + '">See the protocol</a>';
    h += '<a class="bh-btn bh-btn--ghost" href="' + serum + '">Just the serum</a>';
    h += '</div>';
    h += '<form class="bh-q__mail" method="post" action="/contact#bh-q-mail" accept-charset="UTF-8">';
    h += '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">';
    h += '<input type="hidden" name="contact[tags]" value="consultation">';
    h += '<input type="email" name="contact[email]" placeholder="Email me this consultation" aria-label="Email address" required>';
    h += '<button class="bh-btn bh-btn--ghost" type="submit">Send it</button>';
    h += '</form>';
    h += '<p class="bh-small" style="margin-top:10px">Optional. We will not email you anything else unless you ask.</p>';
    h += '<p class="bh-small" style="margin-top:20px"><button type="button" id="bh-q-restart" style="background:none;border:0;padding:0;cursor:pointer;text-decoration:underline;font:inherit;color:inherit">Start again</button></p>';
    h += '</div>';
    mount.innerHTML = h;
    mount.className = '';

    var rs = document.getElementById('bh-q-restart');
    if (rs) { rs.addEventListener('click', function () { A = {}; save(); i = 0; render(); }); }
    toTop();
  }

  back.addEventListener('click', function () { if (i > 0) { i--; render(); } });
  render();
})();
